import React, { PropsWithChildren, useMemo, useState } from 'react';

import { MenuItemEnum } from '@/components/layout/sidebar/sideBarMenu/model/SideBarMenuItems.model';

import { PageContext, PageContextProps, PageDetailsModel } from './Page.context';

export const PageContextProvider: React.FC<PropsWithChildren> = props => {
  const [pageDetails, setPageDetails] = useState<PageDetailsModel>({ title: MenuItemEnum.KNOW_ME });
  const context: PageContextProps = useMemo(() => {
    return {
      pageDetails,
      setPageDetails,
    };
  }, [pageDetails]);

  return (
    <>
      <PageContext.Provider value={context}>{props.children}</PageContext.Provider>
    </>
  );
};
